import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';

function phoneNumber(original) {
  return original?.phoneNumber;
}

function status(original) {
  return original?.status || '';
}

function lastAssignedAt(original) {
  return original?.lastAssignedAt
    ? dayjs(original.lastAssignedAt).format(DATE_FORMAT.LONG_DATE)
    : '-';
}

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original.createdDateTime).format(DATE_FORMAT.LONG_DATE)
    : '-';
}

export { phoneNumber, status, lastAssignedAt, createdDateTime };
